// React
import React from 'react';
import { Controller } from 'react-hook-form';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import FPEPathArray from './components/FPEPathArray';

const FPEEnvironmentHome = (props) => {
  const { control, formState, setValue } = props.methods;
  const { errors } = formState;
  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Paths"
        instructions="Using the controls below, add the page ids of other paths"
      />
      <Controller
        control={control}
        name="content.paths"
        render={({ field }) => (
          <FPEPathArray
            {...{ control, errors, inputDir, setValue }}
            possiblePages={possiblePages}
          />
        )}
      />
    </div>
  );
};

export default FPEEnvironmentHome;
